import { indicizzaPerChiave, perStatoTollerante } from "./statoCanonico";

// Mappatura 1:1 con i valori del campo `stato` in DB. Fonte di verità unica
// per i colori: Badge, Map e Statistics la importano invece di ridefinirla.
export const STATO_ORDER = ["Da programmare", "Programmata", "In corso", "Effettuata", "Rinviata"] as const;

export const STATO_HEX: Record<string, string> = {
  // "Da programmare" e "Programmata" erano rosso e arancio: due gradini
  // adiacenti della stessa rampa termica, indistinguibili a colpo d'occhio
  // proprio dove la distinzione conta di più — "nessuno l'ha ancora messa in
  // calendario" contro "ha una data".
  //
  // "Programmata" passa al blu di PALETTE_EXTRA (già in uso nei grafici): è il
  // colore più lontano dal rosso fra quelli che l'app usa, e "programmato" si
  // legge come informazione, non come allarme. La rampa termica si spezza qui
  // di proposito: rosso = da fare, blu = ha una data, poi giallo/verde per
  // l'avanzamento. Il rosso resta a chi non ha ancora una data, che è l'unico
  // stato che chiede un'azione.
  "Da programmare": "#ef4444",
  Programmata: "#2563eb",
  "In corso": "#eab308",
  Effettuata: "#22c55e",
  Rinviata: "#6b7280",
};

// Indice tollerante: stessa tabella, cercata per chiave normalizzata. Serve
// agli Interventi, il cui `stato` è il nome dello stage Odoo e non combacia
// mai alla lettera ("Programmato", non "Programmata"). Vedi statoCanonico.ts.
const STATO_HEX_PER_CHIAVE = indicizzaPerChiave(STATO_HEX);

/**
 * Colore di uno stato, tollerante su spazi, maiuscole e genere. Da preferire
 * a `STATO_HEX[stato]` ovunque il valore possa non venire dalle liste chiuse
 * dell'app. Restituisce `undefined` per gli stati sconosciuti: il fallback lo
 * sceglie il chiamante — il donut, per esempio, ha una sua palette di riserva.
 */
export function coloreStato(stato: string | null | undefined): string | undefined {
  return perStatoTollerante(STATO_HEX_PER_CHIAVE, stato);
}
